import React, { useEffect, useRef, useState } from 'react';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { USER_TYPES } from 'constant/userTypes';

const useStyles = makeStyles((theme) => ({
  closeIcon: {
    position: 'fixed',
    right: 10,
    top: 10,
  },
  avatar: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    border: '3px solid',
    borderColor: theme.palette.primary.light,
    marginRight: theme.spacing(3),
  },
  bio: {
    whiteSpace: 'break-spaces'
  },
}));

const BioModal = ({ user, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog open fullScreen>
      <IconButton onClick={onClose} className={classes.closeIcon}>
        <CloseIcon />
      </IconButton>
      <Box marginLeft={{ xs: 2, sm: 14, md: 16 }} maxWidth={500} marginBottom={4} marginTop={4} padding={2}>
        <Box display="flex" alignItems="center" marginBottom={4}>
          <Avatar
            className={classes.avatar}
            src={user.user_pic}
          >
            <PersonIcon fontSize="large" />
          </Avatar>
          <div>
            <Typography variant="subtitle1">
              {user.user_first_name}{' '}
              {user.user_last_name}
            </Typography>
            <Typography gutterBottom color="textSecondary">
              {USER_TYPES[user.user_type]}
            </Typography>
          </div>
        </Box>
        <Box>
          <Typography gutterBottom variant="h5">About</Typography>
          <Typography className={classes.bio} component="div" variant="caption" color="textPrimary">{user.profile[0]?.bio}</Typography>
        </Box>
      </Box>
    </Dialog>
  )
}

export default BioModal;